import React from 'react';
import PropTypes from 'prop-types';
import { useColors } from '../../../hooks/useColors';
import { useTextReplacement } from '../../../hooks/useTextReplacement';
import LoadingSpinner from './LoadingSpinner';

const SettingToggle = ({ 
  setting, 
  label, 
  value, 
  isUpdating, 
  onChange,
  description,
  className = ''
}) => {
  const { semantic } = useColors();
  const { replace } = useTextReplacement();
  
  return (
    <div className={`w-full p-3 ${semantic.contentCardBg} ${semantic.contentCardBorder} rounded-lg border ${className}`}>
      <div className="flex items-start justify-between">
        <div className="flex-1">
          <label className={`font-medium ${semantic.formLabel} capitalize`}>
            {replace(label)}
          </label>
          {description && (
            <p className={`text-sm ${semantic.formText} mt-0.5`}>
              {replace(description)}
            </p>
          )}
        </div>
        <div className="relative ml-4 mt-1">
          <button
            type="button"
            className={`
              relative inline-flex h-5 w-9 flex-shrink-0 cursor-pointer rounded-full border-2 
              border-transparent transition-colors duration-200 ease-in-out focus:outline-none 
              focus:ring-2 focus:ring-primary-500
              ${value ? semantic.successBg : 'bg-gray-300 dark:bg-gray-600'}
              ${isUpdating ? 'opacity-50 cursor-not-allowed' : ''}
            `}
            disabled={isUpdating}
            onClick={() => onChange(setting, !value)}
            aria-pressed={value}
            aria-label={replace(label)}
            role="switch"
          >
            <span className="sr-only">{replace(label)}</span>
            <span
              className={`
                pointer-events-none inline-block h-4 w-4 transform rounded-full 
                bg-white shadow ring-0 transition duration-200 ease-in-out
                ${value ? 'translate-x-4' : 'translate-x-0'}
              `}
              aria-hidden="true"
            />
          </button>
          {isUpdating && (
            <div className="absolute inset-0 flex items-center justify-center">
              <LoadingSpinner size="xs" message="" />
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

SettingToggle.propTypes = {
  setting: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  value: PropTypes.bool.isRequired,
  isUpdating: PropTypes.bool,
  onChange: PropTypes.func.isRequired,
  description: PropTypes.string,
  className: PropTypes.string
};

export default SettingToggle;

